import React, { FC } from 'react';
import styled from '@emotion/styled';
import { Colors, colors } from '@modernhealth/vital-foundation';
import { pxToRem } from '@modernhealth/vital-components';

interface ProviderCardProps {
    coverImage: string;
    children: React.ReactNode;
    backgroundColor?: Colors;
    contentBorder?: boolean;
    variant?: 'small' | 'medium';
}

export const ProfileCard: FC<ProviderCardProps> = ({
    coverImage,
    children,
    backgroundColor,
    contentBorder,
    variant = 'medium',
}) => {
    return (
        <ProfileCardContainer variant={variant}>
            <HeaderContainer coverImage={coverImage} variant={variant} />
            <Content backgroundColor={backgroundColor} contentBorder={contentBorder}>
                {children}
            </Content>
        </ProfileCardContainer>
    );
};

const ProfileCardContainer = styled.div<{ variant: string }>(props => ({
    width: props.variant === 'small' ? '100%' : '520px',
}));

const HeaderContainer = styled.div<{ coverImage: string; variant: string }>(props => ({
    height: props.variant === 'small' ? '165px' : '350px',
    backgroundImage: `url("${props.coverImage}")`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    borderRadius: pxToRem(8, 8, 0, 0),
    border: props.variant === 'small' ? 'solid' : 'inherit',
    borderWidth: props.variant === 'small' ? '2px' : 'inherit',
    borderColor: props.variant === 'small' ? colors.gray05 : 'inherit',
    borderBottom: props.variant === 'small' ? 0 : 'inherit',
}));

const Content = styled.div<{ backgroundColor?: Colors; contentBorder?: boolean }>(
    ({ backgroundColor, contentBorder }) => ({
        display: 'flex',
        flexDirection: 'row',
        background: backgroundColor
            ? colors[backgroundColor]
            : `linear-gradient(108.39deg, ${colors.violet05} 5.5%, ${colors.blue10} 95.19%)`,
        borderRadius: pxToRem(0, 0, 8, 8),
        border: contentBorder ? `2px solid ${colors.gray05}` : undefined,
        borderTop: 0,
    }),
);
